module.exports = __webpack_public_path__ + "img/kg.46bc366c.svg";